import { Button } from '@hivebrite/design-system/Button';

import { PayWhen } from 'hb-react/shared/apps/Events/constants/registrationSteps';

const FreeButton = ({ payWhen, isSubmitting, submitForm }) => (
  <Button
    onClick={() => {
      payWhen.current = PayWhen.PAY_NEVER;
      submitForm();
    }}
    isLoading={payWhen.current === PayWhen.PAY_NEVER && isSubmitting}
  >
    {s__('NetworkEvents|Submit')}
  </Button>
);

export default FreeButton;
